import { seoConfig } from "../data/seoConfig";

const absolute = (path) => `${seoConfig.baseUrl}${path}`;

export function itemListSchema({ name, description, path, items, type, getPath }) {
  return {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    name,
    description,
    url: absolute(path),
    mainEntity: {
      "@type": "ItemList",
      numberOfItems: items.length,
      itemListElement: items.map((item, index) => ({
        "@type": "ListItem",
        position: index + 1,
        url: absolute(getPath(item)),
        item: {
          "@type": type,
          name: item.name,
          url: item.website || item.productPage || absolute(getPath(item)),
        },
      })),
    },
  };
}

export function organizationSchema(company) {
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: company.name,
    url: company.website,
    description: company.description,
    address: {
      "@type": "PostalAddress",
      ...(company.city ? { addressLocality: company.city } : {}),
      addressCountry: company.country,
    },
    sameAs: [company.linkedin, company.youtube].filter(Boolean),
  };
}

export function softwareApplicationSchema(software) {
  return {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    name: software.name,
    applicationCategory: "DeveloperApplication",
    operatingSystem: software.operatingSystems.join(", "),
    description: software.description,
    url: software.website,
    author: { "@type": "Organization", name: software.developer },
    softwareHelp: software.documentationUrl || undefined,
    downloadUrl: software.downloadUrl || undefined,
  };
}

export function componentProfileSchema(component, path) {
  const canonical = absolute(path);
  return {
    "@context": "https://schema.org",
    "@type": "TechArticle",
    headline: `${component.name}: verified robot component profile`,
    description: `${component.name} is a ${component.subcategory.toLowerCase()} from ${component.manufacturer.replace(/\.$/, "")}. Specifications vary by model and configuration.`,
    url: canonical,
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": canonical,
    },
    about: {
      "@type": "Thing",
      name: component.name,
      description: `${component.name} is a ${component.subcategory.toLowerCase()} used in robotics applications.`,
      category: component.category,
      manufacturer: { "@type": "Organization", name: component.manufacturer },
      sameAs: component.productPage ? [component.productPage] : undefined,
    },
    author: {
      "@type": "Organization",
      name: "TechniaHQRobot",
      url: `${seoConfig.baseUrl}/about-techniahq`,
    },
    publisher: {
      "@type": "Organization",
      name: "TechniaHQRobot",
      url: `${seoConfig.baseUrl}/`,
    },
    dateModified: component.lastVerified || undefined,
  };
}

export function faqSchema(items) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: items.map((item) => ({
      "@type": "Question",
      name: item.question,
      acceptedAnswer: { "@type": "Answer", text: item.answer },
    })),
  };
}
